// ua
var userAgent = window.navigator.userAgent.toLowerCase();
window.myua = {
  "ie": false,
  "edge": false,
  "chrome": false,
  "safari": false,
  "firefox": false,
  "opera": false
};

if(userAgent.indexOf('msie') != -1 || userAgent.indexOf('trident') != -1) {
  myua.ie = true;
} else if(userAgent.indexOf('edge') != -1) {
  myua.edge = true;
} else if(userAgent.indexOf('chrome') != -1) {
  myua.chrome = true;
} else if(userAgent.indexOf('safari') != -1) {
  myua.safari = true;
} else if(userAgent.indexOf('firefox') != -1) {
  myua.firefox = true;
} else if(userAgent.indexOf('opera') != -1) {
  myua.opera = true;
} else {
}